/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import ContactForm from './ContactForm'
import { fetchContact } from '../../lib/rest/contactAPIClient'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'
import BreadcrumbCard from '../../../../client/js/components/breadcrumb/BreadcrumbCard'
import AdminBreadcrumb from '../../../../client/js/components/breadcrumb/AdminBreadcrumb'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import { getContactListLink } from '../../lib/links/contactLinks'

function ContactFormPage () {
  const intl = useIntl()
  const params = useParams<{ id?: string }>()
  const contactId = parseInt(params.id, 10)

  const contactQuery = useQuery({
    enabled: true,
    queryKey: ['contact', contactId],
    queryFn: () => contactId > 0
      ? fetchContact(contactId)
      : Promise.resolve({} as Partial<Contact>),
    refetchOnWindowFocus: false
  })
  const { data } = contactQuery

  const title = contactId > 0 && data != null
    ? data.name
    : intl.formatMessage({
      id: 'create_contact',
      defaultMessage: 'Créer un contact'
    })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <BreadcrumbCard>
          <AdminBreadcrumb>
            <AnchorLink to={getContactListLink()}>
              <FormattedMessage
                id="contacts"
                defaultMessage="Contacts"
              />
            </AnchorLink>
            <span>{title}</span>
          </AdminBreadcrumb>
        </BreadcrumbCard>

        <Card shadow="sm">
          <LoadingHelper
            query={contactQuery}
            render={() => (
              <ContactForm initialValues={data} />
            )}
          />
        </Card>
      </Container>
    </Page>
  )
}

export default ContactFormPage
